/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { FileCheck2, Scale } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
import { Input } from '@/ui/base/input';
const NS = '/bff/v1/j09-s03-apresentar-defesa';
const b64 = (f: File) =>
  new Promise<string>((ok, no) => {
    const r = new FileReader();
    r.onerror = () => no(r.error);
    r.onload = () => ok(String(r.result).split(',')[1] ?? '');
    r.readAsDataURL(f);
  });
export function ApresentarDefesaPage() {
  const [e, setE] = useState<any>();
  const [busy, setBusy] = useState(false);
  const [auto, setAuto] = useState('');
  const [texto, setTexto] = useState('');
  const [arquivo, setArquivo] = useState<File>();
  async function call(p: string, corpo?: any) {
    setBusy(true);
    try {
      const x = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo });
      setE(x.state);
      return x.state;
    } finally {
      setBusy(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  useEffect(() => {
    if (e && !auto) setAuto(e.autos[0]?.notificacao_id ?? '');
  }, [e, auto]);
  if (!e) return <p role="status">Carregando autos permitidos…</p>;
  const defesa = e.defesas.find((item: any) => item.notificacao_id === auto);
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <Scale className="mr-2 inline h-7 w-7" />
          {e.titulo}
        </h1>
        <p>{e.descricao}</p>
        <p className="text-sm text-muted-foreground">
          Identidade: {e.identidade?.nome_exibicao} · {e.identidade?.email}
        </p>
      </header>
      {e.alertas.map((a: any) => (
        <div role="alert" key={a.codigo} className="rounded-md border border-destructive p-3">
          {a.mensagem} <code>{a.codigo}</code>
        </div>
      ))}
      {e.autos.length === 0 ? (
        <section className="rounded-md border p-4">
          <h2 className="font-semibold">Nenhum auto permitido</h2>
          <p>Não há notificação vinculada a esta identidade.</p>
        </section>
      ) : (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">Inteiro teor e prazo</h2>
          <label>
            Auto
            <select
              className="block h-10 w-full rounded-md border bg-background px-3"
              value={auto}
              onChange={(x) => setAuto(x.target.value)}
            >
              {e.autos.map((a: any) => (
                <option key={a.notificacao_id} value={a.notificacao_id}>
                  {a.numero} · {a.ocorrencia_protocolo}
                </option>
              ))}
            </select>
          </label>
          {e.autos
            .filter((a: any) => a.notificacao_id === auto)
            .map((a: any) => (
              <article key={a.notificacao_id} className="rounded-md bg-muted p-3">
                <p>{a.inteiro_teor}</p>
                <p>
                  Prazo: <strong>{new Date(a.prazo_defesa_em).toLocaleString('pt-BR')}</strong>
                </p>
              </article>
            ))}
          {!defesa && (
            <>
              <label htmlFor="defesa-texto">Fundamentos da defesa</label>
              <textarea
                id="defesa-texto"
                className="min-h-36 w-full rounded-md border bg-background p-3"
                value={texto}
                onChange={(x) => setTexto(x.target.value)}
              />
              <Button
                disabled={busy || texto.trim().length < 20}
                onClick={() =>
                  void call('/verbs/protocolar_defesa', {
                    notificacaoId: auto,
                    texto,
                    chaveIdempotencia: crypto.randomUUID(),
                  })
                }
              >
                Protocolar defesa
              </Button>
            </>
          )}
        </section>
      )}
      {defesa && (
        <section className="space-y-3 rounded-md border p-4">
          <h2 className="font-semibold">Defesa congelada</h2>
          <p>
            <strong>{defesa.protocolo}</strong> · fila {defesa.fila} · versão {defesa.versao}
          </p>
          <p>{defesa.texto}</p>
          <p className="break-all font-mono text-xs">SHA-256 {defesa.texto_hash}</p>
          <p>Decisão suspensa: {defesa.decisao_suspensa ? 'sim' : 'não'}</p>
          <label htmlFor="defesa-arquivo">Documento</label>
          <Input
            id="defesa-arquivo"
            type="file"
            accept="text/plain,application/pdf,image/png,image/jpeg"
            onChange={(x) => setArquivo(x.target.files?.[0])}
          />
          <Button
            disabled={busy || !arquivo}
            onClick={async () =>
              arquivo &&
              call('/verbs/anexar_documento', {
                defesaId: defesa.id,
                nomeArquivo: arquivo.name,
                tipoMime: arquivo.type || 'text/plain',
                conteudoBase64: await b64(arquivo),
                chaveIdempotencia: crypto.randomUUID(),
              })
            }
          >
            <FileCheck2 className="mr-2 h-4 w-4" />
            Anexar documento
          </Button>
          {defesa.anexos.map((a: any) => (
            <article key={a.id} className="rounded-md bg-muted p-3">
              <strong>{a.nome_arquivo}</strong>
              <p>{a.tamanho_bytes} bytes</p>
              <p className="break-all font-mono text-xs">{a.sha256}</p>
            </article>
          ))}
        </section>
      )}
      {e.resultado && (
        <p role="status" className="rounded-md border border-primary p-3">
          Operação persistida: {JSON.stringify(e.resultado)}
        </p>
      )}
    </main>
  );
}
